module.exports = __webpack_public_path__ + "img/icon_list_4.05110b97.png";